import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const getServiceType = () => axios.get(`${apiUrl}serviceTypes`);

export default getServiceType;
